import React from 'react';
import { SuggestionItem } from '../../hooks/useSuggestions';

export interface SearchSuggestionListProps {
  suggestions: SuggestionItem[];
  isVisible: boolean;
  selectedIndex: number;
  onSuggestionClick: (suggestion: SuggestionItem) => void;
  onSuggestionKeyDown: (e: React.KeyboardEvent, index: number) => void;
  testIdPrefix: string;
  className?: string;
  itemClassName?: string;
  selectedItemClassName?: string;
  renderSuggestionContent?: (suggestion: SuggestionItem, index: number) => React.ReactNode;
}

export const SearchSuggestionList: React.FC<SearchSuggestionListProps> = ({
  suggestions,
  isVisible,
  selectedIndex,
  onSuggestionClick,
  onSuggestionKeyDown,
  testIdPrefix,
  className = '',
  itemClassName = '',
  selectedItemClassName = '',
  renderSuggestionContent
}) => {
  if (!isVisible || suggestions.length === 0) {
    return null;
  }

  const defaultRenderContent = (suggestion: SuggestionItem, index: number) => (
    <>
      {suggestion.type && <span className="suggestion-type">{suggestion.type}</span>}
      <span className="suggestion-value">
        {suggestion.display_text || suggestion.value || suggestion.title || ''}
      </span>
    </>
  );

  return (
    <div className={className}>
      {suggestions.map((suggestion, index) => (
        <div
          key={suggestion.id ? `${suggestion.type || 'suggestion'}-${suggestion.id}` : `suggestion-${index}`}
          className={`${itemClassName} ${selectedIndex === index ? selectedItemClassName : ''}`}
          onClick={() => onSuggestionClick(suggestion)}
          onKeyDown={(e) => onSuggestionKeyDown(e, index)}
          tabIndex={0}
          data-testid={`${testIdPrefix}-item-${index}`}
        >
          {renderSuggestionContent ? renderSuggestionContent(suggestion, index) : defaultRenderContent(suggestion, index)}
        </div>
      ))}
    </div>
  );
}; 